import * as t from "io-ts";
import { Approval } from "./Approval";
import { CompanyDirectorReport } from "./CompanyDirectorReport";
import { CompanyReport } from "./CompanyReport";
import { ConsumerReport } from "./ConsumerReport";
import { Metadata } from "./Metadata";
import { OnboardingStage } from "./OnboardingStage";
import { OwnerReport } from "./OwnerReport";

export const Onboarding = t.partial({
  id: t.string,
  cid: t.string,
  oid: t.string,
  aid: t.string,
  current_stage: OnboardingStage,
  stages: t.array(OnboardingStage),
  company_review: t.partial({
    report: CompanyReport,
    approval: Approval,
  }),
  director_review: t.partial({
    reports: t.record(t.string, CompanyDirectorReport),
    approval: Approval,
  }),
  consumer_review: t.partial({
    reports: t.record(t.string, ConsumerReport),
    approval: Approval,
  }),
  owner_review: t.partial({
    reports: t.record(t.string, OwnerReport),
    approval: Approval,
  }),
  insurance_review: t.partial({
    approval: Approval,
  }),
  trade_review: t.partial({
    approval: Approval,
  }),
  online_review: t.partial({
    approval: Approval,
  }),
  fca_upload: t.partial({
    approval: Approval,
  }),
  fca_awaiting_approval: t.partial({
    approval: Approval,
  }),
  shared_note: t.string,
  metadata: Metadata,
});

export interface Onboarding {
  id?: string;
  cid?: string;
  oid?: string;
  aid?: string;
  current_stage?: OnboardingStage;
  stages?: Array<OnboardingStage>;
  company_review?: {
    report?: CompanyReport;
    approval?: Approval;
  };
  director_review?: {
    reports?: Record<string, CompanyDirectorReport>;
    approval?: Approval;
  };
  consumer_review?: {
    reports?: Record<string, ConsumerReport>;
    approval?: Approval;
  };
  owner_review?: {
    reports?: Record<string, OwnerReport>;
    approval?: Approval;
  };
  insurance_review?: {
    approval?: Approval;
  };
  trade_review?: {
    approval?: Approval;
  };
  online_review?: {
    approval?: Approval;
  };
  fca_upload?: {
    approval?: Approval;
  };
  fca_awaiting_approval?: {
    approval?: Approval;
  };
  shared_note?: string;
  metadata?: Metadata;
}
